








import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "OfficeFillableFormDialog",
    props: {
        documentVersion: String,
        documentID: String
    },
    created() {
        this.registerHandlers({ ok: this.oKClicked });
    },
    methods: {
        async oKClicked(): Promise<boolean> {
            let router = this.$router.resolve({
                name: "OfficeOnlineFillableForm",
                query: { document_id: this.documentID, document_version: this.documentVersion.toString() }
            });
            window.open(router.href, "_blank");

            return true;
        }
    }
});
